import { useEffect, useState } from "react";
import { getAgentsBelow } from "../actions";
import { resolveErrorMessage, Roles } from "../util";

const useFetchAgentsBelow = (currentUser, includeCurrentUser) => {
  const [agents, setAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser?.id) return;

    const fetchAgents = async () => {
      try {
        const agentsResult = await getAgentsBelow(currentUser.id, includeCurrentUser);

        if (!agentsResult?.length) {
          throw new Error("app.agents.notFound");
        }
        
        setAgents(agentsResult);
      } catch (e) {
        setError(resolveErrorMessage(e));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAgents();
  }, [currentUser, includeCurrentUser]);

  return {
    agents,
    isLoading,
    error,
  };
};

export default useFetchAgentsBelow;
